<template>
    <div class="section-before-footer">
        <img src="https://ik.imagekit.io/osusf6xvdf/beta/Export_Madam_Ranee_Website_Final_v2-13_tVYF_wnDrCcy.jpg"
            class="section-four-bg is-hidden-touch"
        >
        <img src="https://ik.imagekit.io/osusf6xvdf/beta/home-mobile-3_he1gMyRoJbAl.png"
            class="section-four-bg is-hidden-desktop"
        >
    </div>
</template>

<script>
export default {
  name: 'StandardProductSection',
};
</script>

<style lang="scss" scoped>
.section-before-footer{
  @media screen and (max-width: 768px) {
    margin-top: -100%;
  }
}
</style>
